import { useJournalStore } from '../hooks/useJournalStore';
import type { WidgetProps } from './WidgetRegistry';

const KIND_ICONS: Record<string, string> = {
  timer: '⏰',
  event: '📡',
  human_signal: '👤',
  sibling_publish: '🔀',
  data_arrival: '📊',
};

export function WakeMonitorWidget(_props: WidgetProps) {
  const journal = useJournalStore((s) => s.activeJournal);
  if (!journal) return <div className="text-tower-muted text-sm p-3">No journal loaded</div>;

  const all = [journal.rootContinuation, ...journal.descendants];
  const sleeping = all.filter(c => c.status === 'sleeping' || c.status === 'waiting');

  return (
    <div className="p-2 overflow-y-auto h-full space-y-2">
      {sleeping.length === 0 && <div className="text-tower-muted text-sm p-2">No sleeping continuations</div>}
      {sleeping.map((c) => (
        <div key={c.id} className="p-2 bg-tower-bg rounded border border-tower-border/50 text-xs">
          <div className="flex items-center gap-2 mb-1">
            <span className="w-2 h-2 rounded-full bg-tower-warning" />
            <span className="font-mono text-tower-muted">{c.id.slice(0, 8)}</span>
            <span className="text-tower-text truncate">{c.goalFrame.intent}</span>
          </div>
          {c.wakeConditions.map((w, i) => (
            <div key={i} className="flex items-center gap-1.5 pl-4 text-tower-muted">
              <span>{KIND_ICONS[w.kind] || '?'}</span>
              <span className="text-tower-warning">{w.kind}</span>
              {w.at && <span className="font-mono">{new Date(w.at).toLocaleString()}</span>}
              {w.stream && <span className="font-mono">{w.stream}</span>}
              {w.topic && <span>{w.topic}</span>}
            </div>
          ))}
          {c.nextWakeAt && (
            <div className="pl-4 text-tower-muted mt-1">
              Next wake: <span className="font-mono text-tower-warning">{new Date(c.nextWakeAt).toLocaleString()}</span>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
